/**
 * The wordmark beside the AGU emblem. The brand name is the Dashboard record's
 * own `Name` ("AGU Member Hub"), which also titles the app tile — but next to a
 * mark that already reads "AGU", the leading "AGU " is a stutter ("AGU AGU
 * Member Hub") and, at 16px/800, the reason the brand row overflowed the rail
 * (measured 2026-10-24). A name that is only "AGU", or has no such prefix, is
 * shown as is.
 */
export function SidebarWordmark(brandName: string): string {
    const stripped = brandName.replace(/^AGU\s+/, '');
    return stripped.length > 0 ? stripped : brandName;
}
